import React, { FC, useEffect } from 'react'
import style from './Markdown.module.scss'

export interface MarkdownProps {
  text?: string
}

const Markdown: FC<MarkdownProps> = ({ text = '' }) => {

  return <div className={style['Markdown']} dangerouslySetInnerHTML={{ __html: text }} />

}

export default Markdown
